import { withNamespaces } from "react-i18next";
import { useEffect, useState } from "react";
import AIGetHelpIcon from "src/modules/3rd-party-management/assets/images/microchip/white.png";
import AIBotty from "src/modules/3rd-party-management/assets/images/bottyAi-2.png";

import { Button, Col, Row, Progress, Badge } from "reactstrap";
import { useQuery } from "@tanstack/react-query";
import FindingsService from "src/modules/3rd-party-management/apis/admin/FindingsService";
import { toast } from "react-toastify";

import ModerateIcon from "src/modules/3rd-party-management/assets/images/ai-scoring/Moderate.svg";
import WeakIcon from "src/modules/3rd-party-management/assets/images/ai-scoring/Weak.svg";
import StrongIcon from "src/modules/3rd-party-management/assets/images/ai-scoring/Strong.svg";

import DateUtils from 'src/services/utils/DateUtils';
import  { INTERNATIONAL_DATE_FORMAT } from 'src/common/constants';
import { FindingDateMeta, toDateFromTimestamp } from "../../FindingDates";
const genders = {
    'male': 'Male',
    'female': 'Female'
}

const SanctionDetailBody = ({
    finding,
    t,
    setAiBasedRiskAssessmentModalStatus
}) => {
    const [ aiScoreClass, setAiScoreClass ] = useState(null);
    
    const dateUtils = new DateUtils();

    const handleFetchFindingScoreQuery = useQuery({
		queryKey: ['3rd-party-management-supplier-finding-ai-score-query'],
		queryFn: async () => {
			const service = FindingsService.getInstance();

            return await service.getAIScore({
                promt : `${finding.news_agency || ''}, ${finding.about_url || ''}`
            });
		},
		cacheTime: 0,
        enabled: false,
		refetchOnWindowFocus: false,
		onError: (error) => {
			toast(t('An error occurred while fetching ai score.'), {
				type: 'error',
			});
		},
	});

    const renderAiScoreClassImage = () => {
        let resultImage;

        const scoreClass = (aiScoreClass || '').toString().toLowerCase();

        if(scoreClass === 'class a'){
            resultImage = StrongIcon;
        }
        else if(scoreClass === 'class b'){
            resultImage = ModerateIcon;
        }
        else{
            resultImage = WeakIcon;
        }

        return (
            <img src={ resultImage } alt="" />
        );
    }

    const renderAiScoreClassBox = () => {
        if(handleFetchFindingScoreQuery.isLoading || handleFetchFindingScoreQuery.isFetching || !aiScoreClass){
            return (
                <Col sm="12">
                    <div className="dt-field dt-skeleton w-100" style={{height: '220px'}}></div>    
                </Col>
            );
        }
        
        return (
            <div className="side-box diss-co-score bg-white">
                <div className="scoring">
                    { renderAiScoreClassImage() }
                </div>
            </div>
        );
    }

    useEffect(() => {
        if(finding){
            handleFetchFindingScoreQuery.refetch();
        }
    }, [finding]);

    useEffect(() => {
        if(handleFetchFindingScoreQuery.data && handleFetchFindingScoreQuery.data.out){
            setAiScoreClass(handleFetchFindingScoreQuery.data.out);
        }
    }, [ handleFetchFindingScoreQuery.data ]);

    const displayRelevancyScore = finding && ('relevancyScore' in finding);

    const relevancyScore = parseInt(finding?.relevancyScore);

    const sanctionData = JSON.parse(finding.body);

    return (
        <Row className="d-flex flex-lg-row-reverse">
            <Col sm="12" md="12" lg="4" xl="3" className="d-none d-lg-block">
                <Row>
                    <Col sm="6" md="6" lg="12">
                        <div className="side-box ai-help-box mb-4">
                            <h5>
                                { t('Risk Assessment Support by AI') }
                            </h5>

                            <div className="image-box">
                                <img src={AIBotty} alt="Risk Assessment Support by AI" />
                            </div>

                            <Button onClick={() => {
                                setAiBasedRiskAssessmentModalStatus(true)
                            }} className="d-flex justify-content-center w-100" color="primary">
                                <img className="me-2" src={AIGetHelpIcon} alt="" />
                                { t('Get Help From AI') }
                            </Button>
                        </div>
                    </Col>
                    
                    {displayRelevancyScore && (
                        <Col sm="6" md="6" lg="12">
                            <div className="side-box relevancy-score mb-4">
                                <h5>
                                    { t('Relevancy Score') }
                                </h5>

                                <div className="score-progress-container mt-2 w-100">
                                    <Progress className={relevancyScore < 40 ? 'danger' : (relevancyScore <= 69 ? 'warning' : 'success') } value={relevancyScore} />
                                    <span className="percent">{relevancyScore}%</span>
                                </div>
                            </div>
                        </Col>
                    )}
                    
                    <Col sm="6" md="6" lg="12">
                        { renderAiScoreClassBox() }
                    </Col>
                </Row>
            </Col>

            <Col sm="12" md="12" lg="8" xl="9">
                <div className="finding-content">
                    <div className="alert alert-info">
                        <p className="mb-0">
                            {t('Attention: the Hit can be a false positive as there are many similar names, sepcially in arabic speaking Region')}
                        </p>
                    </div>

                    <div className="sanction-table-container mb-4">
                        <table className="table table-striped">
                            <tbody>
                                <tr>
                                    <td colSpan='2'>
                                        <div className="finding-content-title">
                                            <h5>
                                                {(finding.title)} 
                                                <Badge 
                                                    className="bg-info ms-1 me-2"
                                                >
                                                    PEP
                                                </Badge>
                                                <Badge 
                                                    className="bg-info"
                                                >
                                                    {t('Sanction')}
                                                </Badge>
                                            </h5>
                                        </div>
                                    </td>
                                </tr>
                                {!finding?.is_bafa && toDateFromTimestamp(finding?.release_date) && (
                                    <tr>
                                        <th>{t('Published Date')}</th>
                                        <td>
                                            <FindingDateMeta
                                                id={`detail-release-${finding.id}`}
                                                label="Published Date"
                                                date={toDateFromTimestamp(finding.release_date)}
                                                showLabel={false}
                                                variant="detail"
                                                t={t}
                                            />
                                        </td>
                                    </tr>
                                )}
                                {!finding?.is_bafa && toDateFromTimestamp(finding?.created_at) && (
                                    <tr>
                                        <th>{t('Created At')}</th>
                                        <td>
                                            <FindingDateMeta
                                                id={`detail-created-${finding.id}`}
                                                label="Created At"
                                                date={toDateFromTimestamp(finding.created_at)}
                                                showLabel={false}
                                                variant="detail"
                                                t={t}
                                            />
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <th>{t('Image')}</th>
                                    <td>
                                        <img style={{
                                            maxWidth: '120px'
                                        }} src={sanctionData.profileImage} alt="profile" />
                                    </td>
                                </tr>
                                <tr>
                                    <th>{t('Description')}</th>
                                    <td>
                                        { (sanctionData.description || []).map((i) => <p>{i}</p>) }
                                    </td>
                                </tr>
                                <tr>
                                    <th>{t('Gender')}</th>
                                    <td>
                                        <p>
                                            {t(
                                                genders[sanctionData.gender?.toLowerCase()] || 'Unknown'
                                            )}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{t('Given Names')}</th>
                                    <td>
                                        { (sanctionData.givenName || []).map((name) => {
                                            return (
                                                <p className="mb-1">
                                                    {`${name.firstName} ${name.middleName || ''} ${name.lastName}`}
                                                </p>
                                            )
                                        }) }
                                    </td>
                                </tr>
                                <tr>
                                    <th>{t('Date of Birth')}</th>
                                    <td>
                                        <p>
                                            {sanctionData.birthDate && (
                                                dateUtils.convertDateToDate(
                                                    new Date(sanctionData.birthDate), 
                                                    INTERNATIONAL_DATE_FORMAT
                                                )
                                            )}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{t('Place of Birth')}</th>
                                    <td>
                                        <p>
                                            {sanctionData.birthPlace}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{t('Citizenship')}</th>
                                    <td>
                                        <p>
                                            {sanctionData.citizenship}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{t('Occupations')}</th>
                                    <td>
                                        { (sanctionData.occupations || []).map((i) => <p>{i}</p>) }
                                    </td>
                                </tr>
                                <tr>
                                    <th>{t('Positions')}</th>
                                    <td>
                                        { (sanctionData.positions || []).map((i) => <p>{i}</p>) }
                                    </td>
                                </tr>
                                <tr>
                                    <th>{t('Political Parties')}</th>
                                    <td>
                                        { (sanctionData.politicalParties || []).map((i) => <p>{i}</p>) }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div 
                        className="sanction-table-container"
                        style={{ maxHeight: "350px", overflowY: "auto" }}
                    >
                        {sanctionData.sanctions?.length > 0 && (
                            <table className="table table-striped">
                                <thead
                                    style={{
                                        position: 'sticky',
                                        top: 0,
                                        background: 'white',
                                        zIndex: 2
                                    }}
                                >
                                    <tr>
                                        <td colSpan='6'>
                                            <div className="finding-content-title">
                                                <h5>
                                                    {t('Sanctions')}
                                                </h5>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style={{width: '12%'}}>{t('Evidence ID')}</th>
                                        <th style={{width: '12%'}}>{t('Credibility')}</th>
                                        <th style={{width: '12%'}}>{t('Capture Date')}</th>
                                        <th style={{width: '12%'}}>{t('Publication Date')}</th>
                                        <th style={{width: '20%'}}>{t('Url')}</th>
                                        <th>{t('Summary')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { (sanctionData.sanctions || []).map((san) => {
                                        return (
                                            <tr>
                                                <td>
                                                    {san.evidenceID}

                                                    {san.datasets.includes('PEP-CURRENT') && (
                                                        <Badge
                                                            className="bg-info ms-1 me-2"
                                                        >
                                                            PEP
                                                        </Badge>
                                                    )}

                                                    {san.datasets.includes('SAN-CURRENT') && (
                                                        <Badge
                                                            className="bg-info ms-1 me-2"
                                                        >
                                                            {t('Sanction')}
                                                        </Badge>
                                                    )}
                                                </td>
                                                <td>
                                                    {t(san.credibility)}
                                                </td>
                                                <td>
                                                    {san.captureDateISO && dateUtils.convertDateToDate(
                                                        new Date(san.captureDateISO),
                                                        INTERNATIONAL_DATE_FORMAT
                                                    )}
                                                </td>
                                                <td>
                                                    {san.publicationDateISO && dateUtils.convertDateToDate(
                                                        new Date(san.publicationDateISO),
                                                        INTERNATIONAL_DATE_FORMAT
                                                    )}
                                                </td>
                                                <td>
                                                    <a
                                                        className="text-break"
                                                        href={san.originalURL}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {san.originalURL}
                                                    </a>
                                                </td>
                                                <td>
                                                    {san.summary}
                                                </td>
                                            </tr>
                                        )
                                    }) }
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </Col>
        </Row>
    )
}

export default withNamespaces()(
    SanctionDetailBody
);